export default {
  key_prefix: "dev_oauth2_",
  password: "aAr9MVS9j1",
  api_url: {
    "localhost": "//nethos.diandianys.com/api/app",
    "nethosweb.diandianys.com": "//nethos.diandianys.com/api/app",
    "test-zheer-wx.hztywl.cn": "//nethos.diandianys.com/api/app",
    "pat-test.gjwlyy.com": "//api-test.gjwlyy.com/api/app",
    "www.gjwlyy.com": "http://api.teyangsoft.com/?service=gjwlyy&action=index&sign=1ea3f0c0dd0c91ee54e546a99beafbfb"
  },
  appid: {
    "localhost": "wxa49f90b4ff678ef2",
    "nethosweb.diandianys.com": "wxa49f90b4ff678ef2",
    "test-zheer-wx.hztywl.cn": "wxa49f90b4ff678ef2",
    "pat-test.gjwlyy.com": "wx3d274480f31f6de2",
    "www.gjwlyy.com": "wx3d274480f31f6de2"
  },
  alipay_appid:{
    "nethos-webtest.diandianys.com": "2016021701147425",
    "www.gjwlyy.com": "2014102300014454"
  },
  alipay_oauth2: {
    "nethos-webtest.diandianys.com": "http://nethosapi.diandianys.com",
    "www.gjwlyy.com": "https://api.gjwlyy.com"
  },
  //callback 参数允许跳转的协议白名单（防止 javascript:、data: 等协议绕过域名白名单）
  callback_protocols: ["http", "https"],
  //callback 参数允许跳转的白名单 host
  callback_whitelist: [
    "wx.hztywl.cn",
    "wechat-hljk.huiliaoyiyuan.com",
    "pat.xczsgsyy.com",
    "wechat.xcrmyy.cn",
    "wechat.dhqzxyy.com",
    "fhct-wechat.fhctdyf.com",
    "saas.diandianys.com",
    "wechat.gnxdyrmyy.com",
    "wechat.sbnk.cn",
    "wechat.xhhos.com",
    "wechat.ahnmc.com",
    "test-wx.diandianys.com",
    "szkf-wechat.diandianys.com"
  ],
  base_params: {
    channel: "4",
    format: "JSON",
    oper: "127.0.0.1",
    spid: "1001",
  }
}



// WEBPACK FOOTER //
// ./src/lib/config.js